import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

// Note: the real query field is "LeaveCategorys" — Selise Blocks GraphQL
// pluralizes by literal schema name + "s", not smart/grammatical pluralization.
/** A to Z by title by default, like the old leave-type list's `{ Title: 1 }` sort. */
export const DEFAULT_LEAVE_CATEGORIES_ORDER: OrderBy[] = [{ field: 'Title', direction: 'ASC' }];

export const buildGetLeaveCategoriesQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_LEAVE_CATEGORIES_ORDER
) => `
  query {
    LeaveCategorys: getLeaveCategorys(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        Title
        LeaveLimit
        IsUnlimited
      }
    }
  }
`;

/** Whether any leave request (of any status) is of the category: one is enough to refuse a delete. */
export const buildGetLeaveRequestsOfCategoryQuery = (categoryId: string) => `
  query {
    LeaveRequests: getLeaveRequests(
      where: ${buildWhereLiteral({ LeaveCategoryId: categoryId })}
      order: []
      paging: ${buildPagingLiteral(1, 1)}
    ) {
      totalCount
    }
  }
`;

/** Every HR term's leave allotment category ids, in a stable order: a category an HR term lists can't be
 * deleted. */
export const buildGetTermAllotmentsForCategoryCheckQuery = (pageNo: number, pageSize: number) => `
  query {
    HrProfiles: getUserHRPeriodicalProfiles(
      where: ${buildWhereLiteral({})}
      order: ${buildOrderLiteral([{ field: 'CreatedDate', direction: 'ASC' }])}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        LeaveAllotments {
          LeaveCategoryId
        }
      }
    }
  }
`;
